import { type DataSeriesUnit } from "src/components/monitoring/commonTypes";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { useTheme } from "@mui/material";
import { useMemo } from "react";

export interface DonutChartData {
    id: string;
    /* text displayed in legend and on hover */
    label: string;
    /* elements count per category/state */
    value: number;
    color: string;
    unit?: DataSeriesUnit;
}

export const useUpdateChartData = (data: DonutChartData[], noData: boolean, isLoading?: boolean): DonutChartData[] => {
    const theme: SenecFPPTheme = useTheme();

    return useMemo(() => {
        if (isLoading) return loadingData(theme);
        if (noData) return emptyData(theme);
        return data;
    }, [data, isLoading, noData, theme]);
};

const loadingData = (theme: SenecFPPTheme): DonutChartData[] => [
    {
        id: "loadingData1",
        label: "",
        value: 1,
        color: theme.palette.neutralGray50.main,
    },
    {
        id: "loadingData2",
        label: "",
        value: 0,
        color: theme.palette.neutralGray20.main,
    },
];

const emptyData = (theme: SenecFPPTheme): DonutChartData[] => [
    {
        id: "emptyData",
        label: "",
        value: 1,
        color: theme.palette.neutralGray50.main,
    },
];
